// @ts-strict-ignore
import { createReducer } from '@r/helpers/redux-helpers'
import { FsCore } from '@t/fs-core'
import {
  UpdateProfilePayload,
  updateDeviceProfile,
  setBadCreditCardResult,
  setHasUserCompletedEC,
} from './lead-form-actions'

const profileReducer = createReducer<FsCore.ProfileState>(
  {
    [updateDeviceProfile]: (
      state,
      { profile, dobRequired, profileNotFound, dobWrong }: UpdateProfilePayload,
    ) => {
      return {
        ...state,
        profile,
        dobRequired,
        dobWrong,
        profileNotFound,
      }
    },
    [setBadCreditCardResult]: (state, { isCreditScoreBad }) => ({
      ...state,
      isCreditScoreBad: isCreditScoreBad,
    }),
    [setHasUserCompletedEC]: (state, { hasUserCompletedEC }) => ({
      ...state,
      hasUserCompletedEC: hasUserCompletedEC,
    }),
  },
  {},
)

export default profileReducer
